const initialState = {
  deleteAppointmentStatus: null,
  error: null,
};

const deleteAppointmentReducer = (state = initialState, action) => {
  // console.log("Reducer called with action", action);
  switch (action.type) {
    case "DELETE_APPOINTMENT_SUCCESS":
      return {
        ...state,
        deleteAppointmentStatus: "success",
        error: null,
      };
    case "DELETE_APPOINTMENT_FAILURE":
      return {
        ...state,
        deleteAppointmentStatus: "failure",
        error: action.payload,
      };
    default:
      return state;
  }
};

export default deleteAppointmentReducer;
